<template>
   <v-container>
     <!--Home
        <router-link to="/Home">Home</router-link>
        <router-link to="/Produkte">Produkte</router-link>
        <router-link to="/Service">Service</router-link>
        <router-link to="/Edologic">Edologic</router-link>
        <router-link to="/Impressum">Impressum</router-link>
        <router-link to="/Kontakt">Kontakt</router-link> -->
     <v-layout row wrap>
       <v-flex xs12>
         <v-card flat>
           <v-card-media flat
             class="edomargintop hidden-xs-only"
             height="450px"
             :src="require('../assets/home.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox>
                   <span class="edoheadline">GENIALE PROJEKTE <br> BEGINNEN HIER</span>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
         </v-card>
         <v-card>
           <v-card-media
             class="edomargintop hidden-sm-and-up"
             height="350"
             :src="require('../assets/homeklein.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox>
                   <span class="edoheadline">GENIALE PROJEKTE <br> BEGINNEN HIER</span>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
         </v-card>
       </v-flex>
     </v-layout>
       <v-container fluid grid-list-md>
         <v-layout row wrap justify-space-around>
           <v-flex d-flex xs12 sm6 md5>
             <v-card class="edomargintop" flat>
               <div itemscope itemtype="http://schema.org/Organization">
               <v-card-title primary class="title edoheadlinetext">
                 DIE EDOLOGIC
               </v-card-title>
               <v-card-text class="edoLineText">
                 <span itemprop="name">edologic GmbH</span> <br><br>
                 <div itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
                   <span itemprop="streetAddress">In der Hardt 3</span> <br>
                   <span itemprop="postalCode">42399</span>
                   <span itemprop="addressLocality">Wuppertal</span><br><br>
                 </div>
                 <span itemprop="telephone">+49 202 - 947 996 20 </span><br>
                 <a href="mailto:info@edologic.de"> <span itemprop="email">info@edologic.de </span></a>
               </v-card-text>
               </div>
             </v-card>
           </v-flex>
           <v-flex d-flex xs12 sm6 md5>
             <v-card class="edomargintop" flat>
               <div itemprop="mainEntity" itemscope itemtype="http://schema.org/CreativeWork">
                 <div itemprop="headline">
                   <v-card-title primary class="title edoheadlinetext">KURZ GESAGT</v-card-title>
                 </div>
                 <div itemprop="about">
                   <v-card-text>
                     Das edologic Team ist immer ein fünkchen schneller, da es die Fähigkeit besitzt, sich zu wandeln, sich neu zu erfinden und die Herausforderungen von Morgen schon gestern bewältigt hat. Laufen Sie gemeinsam mit uns über die Ziellinie. Die edologic ist stolz darauf, dass sie seit 10 Jahre neue Trends in der Softwareentwicklung antizipiert.
                   </v-card-text>
                 </div>
               </div>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>
     <v-layout row wrap>
   <v-container>
     <v-card class="edoabstandfooter">
     </v-card>
   </v-container>
     </v-layout>
     </v-container>
</template>

<script>
  // import SitemapGenerator from 'sitemap-generator'
  export default {
    components: {},
    name: 'Home',
    metaInfo: {
      title: 'edologic GmbH - Geniale Projekte beginnen hier',
      // override the parent template and just use the above title only
      titleTemplate: null,
      meta: [
        {
          name: 'description',
          content: 'Innovative Softwarelösungen und atemberaubendes Designs von der edologic – Ihrem Partner für professionelle Softwareentwicklung mit bemerkenswertem Design'
        }]
    },
    data () {
      return {
        'lorem': 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.'
      }
    },
    methods: {
    },
    mounted () {
      console.log('Home')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue